import { Country } from "src/api-service";

// **************************************************************************
// COUNTRY STATE
// **************************************************************************
export interface CountryState {
    /** Current company's country */
    currentCountry: Country | null;
    countryLoading: boolean;
}

export const initialCountryState: CountryState = {
    currentCountry: null,
    countryLoading: false,
};
